import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../components/button/Button";
import { Layout } from "../../../../../components/layout/Layout";

import styles from "./cancel-subscription.module.scss";

export interface CancelSubscriptionProps {
  onCancel(): void;
  onSuccess(): void;
}

export const CancelSubscription: React.FC<CancelSubscriptionProps> = ({ onCancel, onSuccess }) => {
  // access translation keys
  const { t } = useTranslation();

  return (
    <Layout>
      <Button borderRadius="SMALL" color="BLUE" weight="MEDIUM" className={styles.button} onClick={onCancel}>
        {t("No")}
      </Button>
      <Button borderRadius="SMALL" color="LIGHT_RED" weight="MEDIUM" className={styles.button} onClick={onSuccess}>
        {t("Yes")}
      </Button>
    </Layout>
  );
};
